// extracted by mini-css-extract-plugin
export default {"Upload":"Upload_Upload__L9tTX","Upload__icon":"Upload_Upload__icon__HfyLm"};